import React from 'react';

/**
 * Cart-line bag-credit affordances (POS). A $0 line that was auto-applied from a
 * member's bag credit must be instantly distinguishable from a tax-exempt $0 or
 * an errored $0 — so it carries a distinct BAG CREDIT badge, a PERSISTENT on-line
 * explanation with the remaining count, and a decline button as visible as the
 * application. The label text is `bag_credit_label` — the SAME string the receipt
 * prints, from the same backend source, so cart and receipt can't disagree.
 */

export interface BagCreditItem {
  id: number;
  is_donation?: boolean;
  bag_credit_label?: string | null;
}

// Inline badge shown next to the product name (distinct green from TAX EXEMPT).
export const BagCreditBadge: React.FC<{ item: BagCreditItem }> = ({ item }) => {
  if (!item.is_donation) return null;
  return (
    <span
      style={{
        fontSize: 10, color: '#166534', fontWeight: 700, background: '#DCFCE7',
        padding: '1px 5px', borderRadius: 3, marginLeft: 6,
      }}
    >
      BAG CREDIT
    </span>
  );
};

// Persistent explanation row + decline affordance. Renders nothing for a
// non-donation line (so a tax-exempt line shows no bag-credit text).
export const CartBagCreditLine: React.FC<{
  item: BagCreditItem;
  onDecline: (itemId: number) => void;
}> = ({ item, onDecline }) => {
  if (!item.is_donation || !item.bag_credit_label) return null;
  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      gap: 8, marginTop: 2,
    }}>
      <span style={{ fontSize: 12, color: '#166534', fontWeight: 600 }}>
        🎟️ {item.bag_credit_label}
      </span>
      <button
        onClick={() => onDecline(item.id)}
        style={{
          background: 'none', border: '1px solid #16A34A', color: '#166534',
          borderRadius: 4, fontSize: 11, padding: '1px 6px', cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
        title="Ring as a normal sale instead of using bag credit"
      >
        Ring as sale
      </button>
    </div>
  );
};
